(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-ui/shield/assets/javascripts/shield.js') >= 0) return;  svs.modules.push('/components/lb-ui/shield/assets/javascripts/shield.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const _React = React,
  forwardRef = _React.forwardRef;
const _svs$components$lbUi$ = svs.components.lbUi.shield,
  clipPaths = _svs$components$lbUi$.clipPaths,
  Laurels = _svs$components$lbUi$.Laurels;
const _svs$components$lbUti = svs.components.lbUtils,
  clx = _svs$components$lbUti.clx,
  stringToHtml = _svs$components$lbUti.stringToHtml;
const Shield = forwardRef((_ref, ref) => {
  let branding = _ref.branding,
    children = _ref.children,
    className = _ref.className,
    _ref$hasAriaHidden = _ref.hasAriaHidden,
    hasAriaHidden = _ref$hasAriaHidden === void 0 ? undefined : _ref$hasAriaHidden,
    options = _ref.options,
    style = _ref.style;
  const _ref2 = options || {},
    borderColor = _ref2.borderColor,
    color = _ref2.color,
    fillColor = _ref2.fillColor,
    hasHover = _ref2.hasHover,
    hasLaurel = _ref2.hasLaurel,
    hasShadow = _ref2.hasShadow,
    laurelColor = _ref2.laurelColor,
    lightColor = _ref2.lightColor,
    size = _ref2.size;
  const shieldClipPathsElement = document.getElementById('shield-clip-paths');
  if (!shieldClipPathsElement) {
    const fragment = stringToHtml(clipPaths);
    document.body.appendChild(fragment);
  }
  const classes = clx('shield qa-shield', {
    ["shield-".concat(branding)]: branding,
    'shield-hover': hasHover,
    'shield-laurel': hasLaurel,
    'shield-shadow': hasShadow
  }, className);
  const styles = _objectSpread({
    '--shield-border-color': borderColor,
    '--shield-fill-color': fillColor,
    '--shield-light-color': lightColor,
    '--shield-laurel-color': laurelColor,
    '--shield-size': size >= 0 ? "".concat(size, "px") : false,
    '--text-color': color
  }, style);
  return React.createElement("div", {
    "aria-hidden": hasAriaHidden,
    className: classes,
    "data-testid": "qa-shield",
    ref: ref,
    style: styles
  }, React.createElement("div", {
    className: "shield-aspect"
  }, React.createElement("div", {
    className: "shield-graphics"
  }), React.createElement("div", {
    className: "shield-content"
  }, children), hasHover && React.createElement("div", {
    className: "shield-effect"
  }, React.createElement("div", {
    className: "shield-effect-shimmer"
  })), React.createElement(Laurels, {
    isVisible: hasLaurel
  })));
});
setGlobal('svs.components.lbUi.shield.Shield', Shield);

 })(window);